<template>
	<div v-show="hasOrder" class="col-md-12" style="margin-top:20px">
        <div class="card" style="padding:10px 30px 20px 30px" v-if="!loading">
            <div class="car-header" style="text-align:center">
                <h2>Thank You!</h2>
                <h4 class="card-title" v-if="eFundResponse && eFundResponse.status == 'Success'">Please Finalise Your Payment Plan</h4>
                <h4 class="card-title" v-else>Your Order Is Processing Now</h4>
                <p class="category">
                    Please check your email to review your order details.
                </p>
                <p class="category">
                    Once your insurance has been approved the charge will finalised and your policy will be issued.
                </p>
            </div>
            <div class="card-content table-full-width">
                <div class="row" style="margin-top:20px; margin-bottom: 15px">
                    <div class="col-md-12" style="text-align: center">
                        <img :src="warningImageUrl" style="width: 130px" v-if="eFundResponse"/>
                        <img :src="checkedImageUrl" style="width: 130px" v-else/>
                    </div>
                </div>

                <div class="row justify-content-center" v-if="eFundResponse && eFundResponse.status == 'Fail'">
                    <div class="col-md-6 col-md-offset-3">
                        <div class="alert alert-warning text-center">
                            We are processing your order, but your funding application was not approved. Please check your email for more information.
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center" v-if="eFundResponse && eFundResponse.status == 'Success'">
                    <div class="col-md-6 col-md-offset-3">
                        <p class="category text-center" style="margin-bottom: 25px; margin-top: 10px;">
                            We've received your order details. To secure your loan application for this order please follow the link below and fill out the required details. This order will only be processed pending the confirmation of loan.
                        </p>
                        <p style="text-align: center;">
                            <a target="_blank" rel="noopener noreferrer" class="btn btn-warning btn-lg btn-fill btn-wd" :href="eFundResponse.link" style="margin-bottom: 12px;">
                                Complete Loan Application
                                <i class="fa fa-arrow-right"></i>
                            </a>
                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12" style="text-align:center;">
                        <p>Your Order Number Is: <b>{{ order.order_number }}</b></p>
						<p>Order Total: <b>{{ '$' + order_amount_due }}</b> </p>
                        <!-- <p>Amount Paid: <b>{{ '$' + parseFloat(order.total_amount_paid).toFixed(2) }}</b> </p> -->
                        <p>Date Processed: <b>{{ order.processed_at }}</b> </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12" style="text-align:center;">
                        <a class="btn btn-info btn-fill btn-wd" @click="toggleHideDetails()" style="margin-bottom: 12px;">View Details</a>
                    </div>
                    <div class="col-md-12" v-if="!hideDetails" style="text-align:center;">
                        <table class="table" style="text-align:left;">
                            <tbody>
                                <tr>
                                    <td colspan="2">
                                        <h5><b>Order Details</b></h5>
                                    </td>
                                </tr>
                                <tr v-if="underwriter">
                                    <td>Underwriter</td>
                                    <td>
                                        <img
                                            :src="underwriter.logo"
                                            :alt="underwriter.name"
                                            width="104"
                                            height="30" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Postcode</td>
                                    <td>{{ order.postcode_of_risk }}</td>
                                </tr>
                                <tr>
                                    <td>Occupation</td>
                                    <td>{{ occupation.business_activity }}</td>
                                </tr>
                                <tr>
                                    <td>Annual Revenue</td>
                                    <td v-text="`${order.human_annual_revenue} (${order.annual_revenue})`" />
                                </tr>
                                <tr>
                                    <td>Number of Staff</td>
                                    <td>{{ order.head_count }}</td>
                                </tr>
                                <tr>
                                    <td>Period of Cover Required</td>
                                    <td>{{ order.period_of_cover }} months</td>
                                </tr>
                                <tr v-if="order.heat_work_percentage">
                                    <td>Heat Work Percentage</td>
                                    <td>{{ order.heat_work_percentage }}</td>
                                </tr>
                                <tr>
                                    <td>Percentage of Work By Sub-contractors</td>
                                    <td>{{ order.percentage_of_work_by_sub_contractors }}</td>
                                </tr>
                                <tr>
                                    <td>Required Public Liability Amount</td>
                                    <td>{{ order.required_public_liability_amount }}</td>
                                </tr>
                                <tr>
                                    <td>Deductible</td>
                                    <td>{{ order.deductible_as_amount }}</td>
                                </tr>
                                <tr v-if="accidentCover">
                                    <td>Accident Cover</td>
                                    <td>{{ accidentCover.description }}</td>
                                </tr>
                                <tr v-if="accidentCover">
                                    <td>Accident Cover Cost</td>
                                    <td>${{ accidentCover.price }}</td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <h5><b>Endorsements</b></h5>
                                    </td>
                                </tr>
                                <tr v-for="(endorsement, index) in order.endorsements" :key="index">
                                    <td colspan="2">
                                        <span
                                            v-if="endorsement.details"
                                            v-text="endorsement.description"
                                            data-toggle="collapse"
                                            :data-target="'#endorsement-' + endorsement.code"
                                            :aria-controls="'endorsement-' + endorsement.code"
                                            aria-expanded="false"
                                            class="endorsement-details-link"
                                        />
                                        <span
                                            v-else
                                            v-text="endorsement.description"
                                        />
                                        <div
                                            v-if="endorsement.details"
                                            v-html="endorsement.details"
                                            :id="'endorsement-' + endorsement.code"
                                            class="collapse endorsement-details"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <h5><b>Your Details</b></h5>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Customer Name</td>
                                    <td>{{ customer.name }}</td>
                                </tr>
                                <tr>
                                    <td>Gender</td>
                                    <td style="text-transform: capitalize;">{{ customer.gender }}</td>
                                </tr>
                                <tr>
                                    <td>DOB</td>
                                    <td>{{ this.getDOBFormatted(customer.dob) }}</td>
                                </tr>
                                <tr>
                                    <td>Email</td>
                                    <td>{{ customer.email }}</td>
                                </tr>
                                <tr>
                                    <td>Business Name</td>
                                    <td>{{ customer.business_name }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Hide the finish button if loan application has been created -->
                <!-- Because the customer needs to go to eFund and provide their bank details there -->
                <div class="row" v-if="!eFundResponse || eFundResponse.status != 'Success'">
                    <div class="col-md-12" style="text-align:center;">
                        <a :href="redirect" class="btn btn-success btn-fill btn-wd">Finish</a>
                    </div>
                </div>

                <div class="row" v-if="underwriter.product_liability_policy">
                    <div class="col-md-12 m-t-10" style="text-align:center;">
                        <a target="_blank" :href="underwriter.product_liability_policy" rel="noopener noreferrer">Policy Wording</a>
                    </div>
                </div>

            </div>
        </div>
        <p class="text-center" v-else>
            <i class="fa fa-spinner fa-spin"></i> Loading...
        </p>
    </div>
</template>

<script>

	import * as appConfigs from '../configs'
    import store from '../store'
    import { mapState, mapActions, mapGetters } from 'vuex'
    import { isEmpty } from 'lodash'

    // TODO: small refactoring, need to extract the inline style into vue component style tag.
	export default {
        store,
        data: function() {
	        return {
	            order: {},
	            occupation: {},
	            customer: {},
	            locations: {},
	            hideDetails: true,
				total_amount_due: null,
                loading: true
	        }
	    },
		props: {
	        orderId: {
	            required: true
	        },
	        redirect: {
	            required: true
	        },
	    },
	    computed: {
            ...mapState({
                accidentCover: state => state.accidentCover,
                usingCreditCard: state => state.usingCreditCard,
                underwriter: state => state.underwriter,
            }),
            ...mapGetters([
				'totalCostOfInsurance',
			]),
	        hasOrder(){
	            return !isEmpty(this.order)
	        },
            checkedImageUrl(){
                return appConfigs.apiDomain + 'images/checked.png';
            },
            warningImageUrl(){
                return appConfigs.apiDomain + 'images/warning.png';
            },
            eFundResponse() {
                return store.state.eFundResponse
            },
            order_amount_due() {
                var total =  parseFloat(this.totalCostOfInsurance);
                if(!isEmpty(this.order.total_amount_paid)) {
                    total -= parseFloat(this.order.total_amount_paid)
                }

                // if(this.usingCreditCard) {
                //     total += parseFloat(this.order.credit_card_processing_fee)
                // }

                // if(!isEmpty(this.order.accident_cover)) {
                //     total += parseFloat(this.order.accident_cover.price)
                // }

                // if(!isEmpty(this.order.accident_cover)) {
                //     total += parseFloat(this.order.accident_cover.price)
                // }


                return total ? total.toFixed(2) : '0.00'
            },
           
	    },
	    mounted () {
            this.scrollToTop()
	        this.initialOrder()
	    },
        created () {
            if(this.eFundResponse && this.eFundResponse.status == 'Success') {
                this.redirectToLoanApplication()
                this.loading = false
                return
            }
            this.loading = false
        },
	    methods: {
            ...mapActions({
                loadOrder: 'loadOrder',
                scrollToTop: 'scrollToTop',
            }),
	        toggleHideDetails () {
	            this.hideDetails = !this.hideDetails
	        },
	        initialOrder () {
                const orderId = this.orderId
                this.loadOrder({ orderId })
                    .then(order => {
                        this.order = order
                        // Do not need to assigning variables as following, the reason for it is
                        // when using order.customer.name, it will throw an exception for some reason
                        this.occupation = order.occupation
                        this.customer = order.customer
                        this.locations = order.customer.locations
                        this.total_amount_due = (
                            parseFloat(order.gross_premium_inc_charges) +
                            parseFloat(order.service_charge_fee) +
                            parseFloat(order.service_charge_fee_gst)
                        )
                    })
	        },
            redirectToLoanApplication () {
                window.location.replace(this.eFundResponse.link);
            },
             getDOBFormatted(dob){
                if(dob !== undefined && dob !== null){
                    var d = new Date(dob);
                    var day = d.getDate().toString().padStart(2, '0');
                    var month = (d.getMonth() + 1).toString().padStart(2, '0');
                    return day+"-"+month+"-"+d.getFullYear();
                }
                return '';
            }
	    }
	}
</script>

<style lang="scss">
    .endorsement-details {
        color: #999;
    }
    .endorsement-details-link {
        cursor: pointer;
        &:hover {
            text-decoration: underline;
        }
    }
</style>
